import { createFileRoute } from "@tanstack/react-router";
import useShowroomPlanData from "lib/components/showroom2/data/useShowroomPlanData";
import ShowroomSandbox from "lib/components/showroom2/pages/ShowroomSandbox";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import { procurePath, useAppRouterParams } from "lib/routeHelpers";
import { useEffect } from "react";
import { SHEETS_DEFAULT_PAGE } from "./bigscreen";

function ShowroomSandboxPage() {
  const { builderId: routeBuilderId, id } = useAppRouterParams();
  const showroomKey = [routeBuilderId, id].filter(Boolean).join("-") || undefined;
  const planData = useShowroomPlanData();

  const studioDocId = planData?.masterPlan?.studioDocId;
  const builderId = planData?.builder?.id;
  const communityPlanId = planData?.communityPlan?.id;
  useEffect(() => {
    if (studioDocId && builderId && communityPlanId) {
      window.open(
        `${window.location.origin}/demo/sheets${window.location.search}&page=${encodeURIComponent(
          SHEETS_DEFAULT_PAGE,
        )}`,
        "_blank",
      );

      window.open(`${window.location.origin}/${procurePath({ studioDocId, communityPlanId, builderId })}`, "_blank");
    }
  }, [builderId, studioDocId, communityPlanId]);
  return (
    <ShowroomProvider key={showroomKey}>
      <ShowroomSandbox />
    </ShowroomProvider>
  );
}

export const Route = createFileRoute("/demo/connected/tabs")({
  component: ShowroomSandboxPage,
  staticData: { isPublicPage: true },
});
